module.exports = __webpack_public_path__ + "static/media/main.04325858.png";